import InstancedSpheresGeometry from './InstancedSpheresGeometry';
import SimpleSpheresGeometry from './SimpleSpheresGeometry';
import Simple2CCylindersGeometry from './Simple2CCylindersGeometry';
import Instanced2CCylindersGeometry from './Instanced2CCylindersGeometry';
import ExtrudedObjectsGeometry from './ExtrudedObjectsGeometry';
import ChunkedLinesGeometry from './ChunkedLinesGeometry';
import TwoColorLinesGeometry from './TwoColorLinesGeometry';
import CrossGeometry from './CrossGeometry';
import QuickSurfGeometry from './QuickSurfGeometry';
import ContactSurfaceGeometry from './ContactSurfaceGeometry';
import SSIsosurfaceGeometry from './SSIsosurfaceGeometry';
import LabelsGeometry from './LabelsGeometry';

export default {
  InstancedSpheresGeometry,
  SimpleSpheresGeometry,
  Simple2CCylindersGeometry,
  Instanced2CCylindersGeometry,
  ExtrudedObjectsGeometry,
  ChunkedLinesGeometry,
  TwoColorLinesGeometry,
  CrossGeometry,
  QuickSurfGeometry,
  ContactSurfaceGeometry,
  SSIsosurfaceGeometry,
  LabelsGeometry,
};
